module.exports = "<label class=\"kl-switch kl-switch--{size} {class}\" is-dis={disabled} is-chk={checked}>\n  <input type=\"checkbox\" class=\"f-dn\" disabled={disabled} on-change={this.onChange($event)} />\n  <span class=\"kl-switch__slider\">\n    {#if checked && checkedText}\n      <span class=\"kl-switch__checkedText\">{#inc checkedText}</span>\n    {#elseif !checked && unCheckedText}\n      <span class=\"kl-switch__unCheckedText\">{#inc unCheckedText}</span>\n    {/if}\n  </span>\n</label>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLSwitch/index.html
// module id = 451
// module chunks = 0